import { render, staticRenderFns } from "./personAdd.vue?vue&type=template&id=9f9cf25e&scoped=true&"
import script from "./personAdd.vue?vue&type=script&lang=js&"
export * from "./personAdd.vue?vue&type=script&lang=js&"
import style0 from "./personAdd.vue?vue&type=style&index=0&id=9f9cf25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9cf25e",
  null
  
)

export default component.exports